import { AxiosError, AxiosResponse } from 'axios';
import { ErrorDetails, ErrorResponseData, ErrorResponse } from '../types/errors';
import {
  ERRORS_TO_SHOW,
  DEFAULT_INTERNAL_ERROR_MESSAGE,
  DEFAULT_BUSINESS_ERROR_MESSAGE,
  DEFAULT_LANGUAGE,
  ERROR_MESSAGES,
} from '../constants/errors';

export const getInternalErrorMessage = (language: string): string => {
  return (
    ERROR_MESSAGES[language]?.[DEFAULT_INTERNAL_ERROR_MESSAGE] ??
    ERROR_MESSAGES[DEFAULT_LANGUAGE][DEFAULT_INTERNAL_ERROR_MESSAGE]
  );
};

export const getBusinessErrorMessage = (language: string): string => {
  return (
    ERROR_MESSAGES[language]?.[DEFAULT_BUSINESS_ERROR_MESSAGE] ??
    ERROR_MESSAGES[DEFAULT_LANGUAGE][DEFAULT_BUSINESS_ERROR_MESSAGE]
  );
};

const getErrorMessageToShow = (errorDetails: ErrorDetails, language: string): string => {
  const message = errorDetails?.message;
  const code = errorDetails?.code;

  if (code && ERRORS_TO_SHOW.includes(code)) {
    return message;
  }
  return getBusinessErrorMessage(language);
};

/**
 * This is temporary until we have a better way to handle errors in the bff
 * @param error
 * @returns
 */
const getErrorMessage = (response: AxiosResponse<any, any>, language: string): string => {
  const details = response.data?.details?.[0]?.details;
  const messageToPurchaser = response.data?.message_to_purchaser;
  const message = response.data?.message;

  if (details) {
    const errorMessage = getErrorMessageToShow(details[0], language);
    if (errorMessage) {
      return errorMessage;
    }
  }

  if (messageToPurchaser) {
    return messageToPurchaser;
  }

  if (message) {
    return message;
  }

  return getBusinessErrorMessage(language);
};

export const parseSpecialErrors = (error: AxiosError<ErrorResponseData>, language: string): string => {
  if (error.response) {
    return getErrorMessage(error.response, language);
  }
  return getInternalErrorMessage(language);
};

export const buildInternalErrorDTO = (errorMessage: string): ErrorResponse => ({
  data: {
    message: errorMessage,
    details: [{ details: [{ message: errorMessage }] }],
  },
  status: 502,
  statusText: 'Bad Gateway',
  headers: {},
  config: {
    headers: {},
    method: 'GET',
    url: '',
    data: undefined,
    timeout: 0,
    withCredentials: false,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: undefined,
  },
});
